// Test IDs for the Pulse Agentic marketing/landing page sections.

export const NAV = {
	header: 'nav-header',
	logo: 'nav-logo',
	linkManifesto: 'nav-link-manifesto',
	linkCapabilities: 'nav-link-capabilities',
	linkWork: 'nav-link-work',
	linkContact: 'nav-link-contact',
	ctaButton: 'nav-cta-button',
	mobileMenuToggle: 'nav-mobile-menu-toggle',
	mobileMenu: 'nav-mobile-menu',
};

export const HERO = {
	section: 'hero-section',
	eyebrow: 'hero-eyebrow',
	headline: 'hero-headline',
	subheadline: 'hero-subheadline',
	ctaButton: 'hero-cta-button',
	scrollIndicator: 'hero-scroll-indicator',
};

export const MANIFESTO = {
	section: 'manifesto-section',
	intro: 'manifesto-intro',
	chapter: (n) => `manifesto-chapter-${n}`,
};

export const CAPABILITIES = {
	section: 'capabilities-section',
	card: (slug) => `capabilities-card-${slug}`,
};

export const WORK = {
	section: 'work-section',
	card: (slug) => `work-card-${slug}`,
};

export const MARQUEE = {
	section: 'editorial-marquee',
};

export const CONTACT = {
	section: 'contact-section',
	nameInput: 'contact-name-input',
	emailInput: 'contact-email-input',
	messageInput: 'contact-message-input',
	submitButton: 'contact-submit-button',
	emailLink: 'contact-email-link',
	phoneLink: 'contact-phone-link',
	address: 'contact-address',
};

export const FOOTER = {
	section: 'footer-section',
	logo: 'footer-logo',
};
